module Eseebase {

    export class TutorialViewModel {
        id: string;
        title: string;
        videoUrl: string;
    }
}